<script setup>
const props = defineProps({
  data: Object,
  pulseData: Object,
  gridData: Object
})
const { getRecShared } = useLeadGenRecData();
const { data: recSharedData } = await getRecShared();
const genreValues = toRef(props, 'pulseData');
const genreData = toRef(props, 'gridData');

const items = props.data.sharedContent && props.data.genre.length > 0 || props.data.sharedContent ? recSharedData.value.data.attributes.genre : props.data.genre ;
// Modify the items array to add the value extracted from genreLabels
const itemsWithValue = items.map(item => {
  // Extract the value from genreLabels using regex
  const match = item.genreLabels.match(/\((\d+)\s?\)$/);
  // If a match is found, extract the value, otherwise use null
  const value = match ? parseInt(match[1]) : null;
  // Return the item with the added value
  return { ...item, value };
});
const selectedItems = ref([]);
const emit = defineEmits('validateStep');

const toggleSelection = (item) => {
  const index = selectedItems.value.indexOf(item.value);
  if (index === -1) {
    selectedItems.value.push(item.value);
  } else {
    selectedItems.value.splice(index, 1);
  }
  emit("validateStep", {
    value: selectedItems.value,
    component: props.data.component
  });
  genreValues.value.studentGenreTypeIDs = selectedItems.value;
  genreData.value.interests = selectedItems.value;
};
const isSelected = (value) => {
  return selectedItems.value.includes(value);
};
onMounted(() => {
  const parentElement = document.getElementById('genre-select').parentElement.parentElement.parentElement
  
  const observer = new MutationObserver((mutationsList, observer) => {
    for (var mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style' && parentElement.style.display !== 'none') {
        emit('validateStep', {
          value: selectedItems.value,
          component: props.data.component
        });
      }
    }
  });
  observer.observe(parentElement, { attributes: true});
})
</script>

<template>
  <div class="genre-select btn-wrapper btn-group" id="genre-select">
    <button 
      v-for="item in itemsWithValue"
      :key="item.id"
      class="btn-quiz flex-grow-1"
      :class="{ active: isSelected(item.value) }"
      @click="toggleSelection(item)"
    >
      <span class="quiz-button-content">
      <span v-if="isSelected(item.value)" class="bi-check"></span>
      <span v-else class="space"></span>
      <span>{{ item.genre }}</span>
      </span>
    </button>
  </div>
</template>

<style lang="scss" scoped>
$breakpoint-xs-max: 400px;
.genre-select {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(135px, 1fr));
  gap: 15px; /* Space between buttons */
  
  @include media-breakpoint-down($breakpoint-xs-max) {
    text-wrap: nowrap;
    overflow: hidden;
  }
}
.btn-wrapper.btn-group {
  .btn-quiz {
    padding: 0 10px;
    .space {
      width: 0;
    }
    .quiz-button-content {
      display: flex;
      align-items: center;
      justify-content: center;
      align-self: center;
    }
  }
}

</style>
